import React from 'react';
import './StrumPatternDisplay.css';

// Count labels for 8th-note grid positions within a measure.
// Even positions are on-beat (1,2,3,4…); odd positions are upbeats (+).
function buildCountLabels(beatsPerMeasure) {
  const labels = [];
  for (let b = 0; b < beatsPerMeasure; b++) {
    labels.push(String(b + 1));
    labels.push('+');
  }
  return labels;
}

// Build a blank cell grid when no pattern is available yet.
function buildEmptyCells(beatsPerMeasure) {
  const n = (beatsPerMeasure || 4) * 2;
  return Array.from({ length: n }, (_, i) => ({ pos: i, dir: '' }));
}

function StrumPatternDisplay({ strumPattern, beatsPerMeasure }) {
  const bpm = beatsPerMeasure || 4;
  const cells = strumPattern?.patternCells ?? buildEmptyCells(bpm);
  const countLabels = buildCountLabels(bpm);
  const hasPattern = !!(strumPattern?.patternCells);
  const confidencePct = hasPattern ? Math.round((strumPattern.confidence || 0) * 100) : null;

  return (
    <div
      className={`strum-display${hasPattern ? '' : ' strum-display--empty'}`}
      aria-label={hasPattern ? `Strum pattern: ${strumPattern.pattern}` : 'Strum pattern not yet detected'}
    >
      <span className="strum-display__label">Strum</span>
      <div className="strum-display__body">
        <div className="strum-display__grid">
          {cells.map((cell, i) => {
            const isOnBeat = i % 2 === 0;
            const dir = cell.dir || '';
            return (
              <div
                key={i}
                className={`strum-cell strum-cell--${dir || 'none'}${isOnBeat ? ' strum-cell--onbeat' : ''}`}
              >
                <span className="strum-cell__arrow" aria-hidden="true">
                  {dir === 'D' ? '↓' : dir === 'U' ? '↑' : '·'}
                </span>
                <span className="strum-cell__count">{countLabels[i] ?? ''}</span>
              </div>
            );
          })}
        </div>
        <span className="strum-display__confidence">
          {confidencePct !== null ? `${confidencePct}% conf` : '—'}
        </span>
      </div>
    </div>
  );
}

export default StrumPatternDisplay;
